import { SVGProps } from 'react';
import { cn } from '../../utils';

export const CheckboxBlocked = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('shrink-0', className)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.14305 6.42933H2.85733V3.57219C2.85733 2.39076 3.81876 1.42933 5.00019 1.42933C6.18162 1.42933 7.14305 2.39076 7.14305 3.57219V6.42933ZM4.99987 11.4309C4.40844 11.4309 3.92844 10.9509 3.92844 10.3594C3.92844 9.768 4.40844 9.288 4.99987 9.288C5.5913 9.288 6.0713 9.768 6.0713 10.3594C6.0713 10.9509 5.5913 11.4309 4.99987 11.4309ZM8.57143 6.42857V3.57143C8.57143 1.60214 6.96929 0 5 0C3.03071 0 1.42857 1.60214 1.42857 3.57143V6.42857C0.640714 6.42857 0 7.06857 0 7.85714V12.8571C0 13.645 0.640714 14.2857 1.42857 14.2857H8.57143C9.35929 14.2857 10 13.645 10 12.8571V7.85714C10 7.06857 9.35929 6.42857 8.57143 6.42857Z"
      fill="currentColor"
    />
  </svg>
);
